import { render, staticRenderFns } from "./ServiceAreasDashboardBlockoutDaysComponent.vue?vue&type=template&id=58700d30&scoped=true&"
import script from "./ServiceAreasDashboardBlockoutDaysComponent.vue?vue&type=script&lang=js&"
export * from "./ServiceAreasDashboardBlockoutDaysComponent.vue?vue&type=script&lang=js&"
import style0 from "./ServiceAreasDashboardBlockoutDaysComponent.vue?vue&type=style&index=0&id=58700d30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58700d30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58700d30')) {
      api.createRecord('58700d30', component.options)
    } else {
      api.reload('58700d30', component.options)
    }
    module.hot.accept("./ServiceAreasDashboardBlockoutDaysComponent.vue?vue&type=template&id=58700d30&scoped=true&", function () {
      api.rerender('58700d30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/ServiceAreas/Dashboard/ServiceAreasDashboardBlockoutDaysComponent.vue"
export default component.exports